<template>
  <div class="container-fluid">
    <div class="block-header">
      <bread-crumb></bread-crumb>
    </div>
    <div class="row clearfix">
      <div class="col-md-12">
        <div class="card card-top-line">
          <ValidationObserver v-slot="{ passes }">
            <div class="header">
              <h2>Add Affiliate Code</h2>
            </div>
            <div class="body">
              <form @submit.prevent="passes(affiliateCodeSubmit)">
                <ValidationProvider
                  name="customer"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <div
                    class="form-group form-select single-multiselect select-option-custom"
                    :class="{
                      errors: errors[0],
                      success: affiliateCode.customer && !errors[0],
                    }"
                  >
                    <span class="float-label">
                      <label for="customer">Select Customer*</label>
                      <multiselect
                        placeholder=""
                        v-model="affiliateCode.customer"
                        :show-labels="false"
                        :options="options"
                        :searchable="true"
                        @search-change="searchCustomer"
                        track-by="name"
                        label="name"
                      >
                        <template #option="props">
                          <div class="option__desc">
                            {{ props.option.name + ` (${props.option.email})` }}
                          </div>
                        </template>
                      </multiselect>
                      <i
                        class="fa fa-times"
                        v-if="errors.length && errors[0]"
                      ></i>
                      <i
                        class="fa fa-check"
                        v-if="affiliateCode.customer && !errors[0]"
                      ></i>
                    </span>
                  </div>
                </ValidationProvider>
                <ValidationProvider
                  name="affiliate_code"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <div
                    class="d-md-flex justify-content-between align-items-center mb-2"
                  >
                    <div
                      class="form-group w-100 mb-0 mr-1"
                      :class="{
                        errors: errors.length && !affiliateCode.affiliate_code,
                        success: affiliateCode.affiliate_code,
                      }"
                    >
                      <span class="float-label">
                        <input
                          type="text"
                          v-model="affiliateCode.affiliate_code"
                          class="form-control"
                          placeholder="Affiliate Code"
                        />
                        <label for="cms" class="control-label">
                          Affiliate Code*
                        </label>
                        <div class="line"></div>
                        <i
                          class="fa fa-times"
                          v-if="errors.length && !affiliateCode.affiliate_code"
                        ></i>
                        <i
                          class="fa fa-check"
                          v-if="affiliateCode.affiliate_code"
                        ></i>
                      </span>
                    </div>
                    <b-button class="btn btn-auto" variant="outline-primary">
                      Check Availability
                    </b-button>
                  </div>
                </ValidationProvider>
                <div
                  class="d-none flex-column flex-md-row justify-content-center"
                >
                  <b-button
                    variant="secondary btn-mw"
                    size="lg"
                    @click="$router.back()"
                  >
                    Cancel
                  </b-button>
                  <b-button
                    type="submit"
                    variant="primary ml-md-1 mt-2 mt-md-0 btn-mw"
                    size="lg"
                  >
                    Submit
                  </b-button>
                </div>
              </form>
            </div>
          </ValidationObserver>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const BreadCrumb = require("@/components/BreadCrumb.vue").default;
const { ValidationObserver, ValidationProvider } = require("vee-validate");
export default {
  name: "AddAffiliateCodeComponent",
  components: {
    BreadCrumb,
    Multiselect: () => import("vue-multiselect"),
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      affiliateCode: {
        customer: "",
        affiliate_code: "",
      },
      options: [],
    };
  },
  methods: {
    affiliateCodeSubmit() {
      console.log(this.affiliateCode);
    },
    searchCustomer($event) {
      if ($event.length > 0) {
        this.options = [
          { name: "Adam Driver", email: "AdamD@yopmail.com" },
          { name: "Dominic Torreto", email: "Dominic@hotmail.co" },
          { name: "Brain O'Conner", email: "connerBrain@mailinator.com" },
          { name: "Mark Chalamet", email: "mark21@test.com" },
          { name: "Robert Evans", email: "robEv12@yahoo.com" },
          { name: "Emma Thomas", email: "emthomas@mail.com" },
          { name: "Alizee Thomas", email: "alizze.th@hotmail.com" },
          { name: "Selena Parker", email: "selena.tp@test.in" },
          { name: "Hal Chalamet", email: "halC12@gmail.com" },
          { name: "Ben Murphy", email: "benPM99@gmail.com" },
        ];
      } else {
        this.options = [];
      }
    },
  },
  mounted() {
    //
  },
};
</script>
